import Vue from 'vue'
import BreadCumb from '@/components/BreadCumb'
import Card from '@/components/Card'
import BodyCard from '@/components/BodyCard'
import BaseTable from '@/components/BaseTable'
import SelectColumnCheck from '@/components/SelectColumnCheck'
import ImgShow from '@/components/ImgShow'

Vue.component('breadcumb', BreadCumb)
Vue.component('card', Card)
Vue.component('body-card', BodyCard)
Vue.component('base-table', BaseTable)
Vue.component('select-column-check', SelectColumnCheck)
Vue.component('image-show', ImgShow)
